import React from "react";
import styled from "styled-components";

function ExtendSection(props) {
  const lang = props.lang;
  return (
    <div
      style={{ display: "flex", flexDirection: "column", width: "100%" }}
      id="roadmap"
    >
      <Section1 lang={lang} />
      <Section2 lang={lang} />
      <Section3 lang={lang} />
      <Section4 lang={lang} />
    </div>
  );
}

function Section1(props) {
  const lang = props.lang;
  const [isMobile, setIsMobile] = React.useState(true);
  React.useEffect(() => {
    setIsMobile(
      typeof window !== "undefined" ? window.screen.width < 800 : true
    );
  }, []);
  return (
    <div
      style={{
        backgroundColor: "#4b4bff",
        display: "flex",
        paddingTop: 40,
        paddingBottom: isMobile ? 40 : 0,
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <h1 style={{ color: "white" }}>
        {lang === "tw" ? "延伸賦能" : "Extension"}
      </h1>
      <div
        style={{ display: "flex", flexDirection: isMobile ? "column" : "row" }}
      >
        <img src="/ExtendSection1.png" width="300" />
        <div
          style={{
            display: "flex",
            width: 300,
            paddingTop: 40,
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            marginLeft: 20,
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              backgroundColor: "#FFE500",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              color: "black",
              fontSize: 32,
            }}
          >
            1
          </div>
          <h2 style={{ marginTop: 30, color: "white" }}>
            {lang === "tw" ? "實體認證" : "Physical Form"}
          </h2>
          <div style={{ marginTop: 20, color: "white" }}>
            {lang === "tw"
              ? "將 NFT 封裝於冷錢包裝置，讓 NFT 不再只是純虛擬商品並增加不同互動性及達到品牌宣傳目的"
              : "Encapsulate NFT to hardware form to enable offline liquidity"}
          </div>
        </div>
      </div>
    </div>
  );
}

function Section2(props) {
  const lang = props.lang;
  const [isMobile, setIsMobile] = React.useState(true);
  React.useEffect(() => {
    setIsMobile(
      typeof window !== "undefined" ? window.screen.width < 800 : true
    );
  }, []);
  return (
    <div style={{ backgroundColor: "#EEEEEE" }}>
      <div
        style={{
          backgroundImage: 'url("/ExtendSection-2-2.png")',
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          height: "70vh",
          display: "flex",
          flexDirection: "row",
          justifyContent: isMobile ? "center" : "flex-start",
          alignItems: "center",
          paddingLeft: isMobile ? 0 : "20%",
        }}
      >
        <div
          style={{
            display: "flex",
            width: 300,
            paddingTop: 40,
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            marginLeft: 20,
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              backgroundColor: "black",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              color: "white",
              fontSize: 32,
            }}
          >
            2
          </div>
          <h2 style={{ marginTop: 30, color: "black" }}>
            {lang === "tw" ? "系統開發" : "System Integration"}
          </h2>
          <div style={{ marginTop: 20, color: "black" }}>
            {lang === "tw"
              ? "以 Web3 提升原有系統的發展潛力。將 NFT 及區塊鏈作為原系統外掛，開展全新的商業模式"
              : "Make Web3 as a plugin to extend legacy business model"}
          </div>
        </div>
      </div>
    </div>
  );
}

function Section3(props) {
  const lang = props.lang;
  const [isMobile, setIsMobile] = React.useState(true);
  React.useEffect(() => {
    setIsMobile(
      typeof window !== "undefined" ? window.screen.width < 800 : true
    );
  }, []);
  return (
    <div
      style={{
        backgroundImage: 'url("/ExtendSection2-3.png")',
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        height: "80vh",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: isMobile ? "center" : "flex-end",
        paddingTop: 40,
        paddingBottom: isMobile ? 60 : 0,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "center" : "stretch",
        }}
      >
        <img src="/ExtendSection2-4.png" width="300" />

        <div
          style={{
            alignSelf: "center",
            display: "flex",
            width: 300,
            paddingTop: 40,
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            marginLeft: 20,
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              backgroundColor: "black",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              color: "white",
              fontSize: 32,
            }}
          >
            3
          </div>
          <h2 style={{ marginTop: 30, color: "black" }}>
            {lang === "tw" ? "智能合約" : "Smart Contract"}
          </h2>
          <div style={{ marginTop: 20, color: "black" }}>
            {lang === "tw"
              ? "有別於一般公版智能合約，HiNFT 客製化邏輯以延伸至質押或後續賦能所需的必要功能"
              : "For special business requiment, add new logic to smart contract"}
          </div>
        </div>
      </div>
    </div>
  );
}

function Section4(props) {
  const lang = props.lang;
  const [isMobile, setIsMobile] = React.useState(true);
  React.useEffect(() => {
    setIsMobile(
      typeof window !== "undefined" ? window.screen.width < 800 : true
    );
  }, []);
  return (
    <div style={{ backgroundColor: "black" }}>
      <div
        style={{
          backgroundImage: 'url("/ExtendSection2-5.png")',
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          height: "70vh",
          display: "flex",
          flexDirection: "row",
          justifyContent: isMobile ? "center" : "flex-start",
          alignItems: "center",
          paddingLeft: isMobile ? 0 : "20%",
        }}
      >
        <div
          style={{
            display: "flex",
            width: 300,
            paddingTop: 40,
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            marginLeft: 20,
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              backgroundColor: "#4B4BFE",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              color: "white",
              fontSize: 32,
            }}
          >
            4
          </div>
          <h2 style={{ marginTop: 30, color: "white" }}>
            {lang === "tw" ? "法幣整合" : "Fiat Currency"}
          </h2>
          <div style={{ marginTop: 20, color: "white" }}>
            {lang === "tw"
              ? "藉法幣整合讓整體系統出圈至一般普羅大眾，擴充既有品牌的影響力和發展彈性"
              : "Aquire new TA by fiat currency supporting"}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExtendSection;
